const moduleName = 'globalSpinner';

export const isGlobalSpinnerVisibleSelector = state => !!state[moduleName].spinners.length;
